import { CoreError, assertSafeInt } from './errors'

/** Quantities are integer milli-units: 1000 = 1 unit, 1500 = 1.5 units. */
export type Milli = number

export const MILLI = 1000

/**
 * Parses "2", "1.5", "0.250" into milli-units. Units that don't allow decimals
 * (e.g. pieces) reject fractions.
 */
export function parseQty(input: string, allowsDecimal = true): Milli {
  const match = /^\s*(\d*)(?:\.(\d{0,3}))?\s*$/.exec(input)
  if (!match || (match[1] === '' && (match[2] ?? '') === '')) {
    throw new CoreError('invalid_qty', `"${input}" is not a quantity`)
  }
  const fraction = (match[2] ?? '').padEnd(3, '0')
  if (!allowsDecimal && Number(fraction) !== 0) {
    throw new CoreError('invalid_qty', 'this unit does not allow decimals')
  }
  const milli = Number(match[1] || '0') * MILLI + Number(fraction)
  assertSafeInt(milli, 'quantity')
  return milli
}

/** 1500 → "1.5", 2000 → "2", 250 → "0.25" */
export function formatQty(milli: Milli): string {
  assertSafeInt(milli, 'quantity')
  const sign = milli < 0 ? '-' : ''
  const abs = Math.abs(milli)
  const whole = Math.floor(abs / MILLI)
  const fraction = (abs % MILLI).toString().padStart(3, '0').replace(/0+$/, '')
  return fraction ? `${sign}${whole}.${fraction}` : `${sign}${whole}`
}
